export const MY_BOOKINGS_TYPES = {
	UPCOMING: "UPCOMING",
	PAST: "PAST",
};
